import { universalFetch } from "./common";
// import { cmaData } from "../mocks/cmaData";
import type {  CmaResponse } from "../interfaces/cmaInterface";

export const fetchCMA = async (listingId: string): Promise<CmaResponse> => {
  try {
    console.log("fetchCMA listingId:", listingId);
    const response = await universalFetch(
      `/listings/${listingId}/cma`,
      "GET"
    );
    console.log("fetchOuting response:", response);

    return response as CmaResponse;
  } catch (error) {
    console.error("Failed fetchCartProperties", error);
    throw error;
  }
};
